import { render, staticRenderFns } from "./collectOrder.vue?vue&type=template&id=4052e404&scoped=true&"
import script from "./collectOrder.vue?vue&type=script&lang=js&"
export * from "./collectOrder.vue?vue&type=script&lang=js&"
import style0 from "./collectOrder.vue?vue&type=style&index=0&id=4052e404&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4052e404",
  null
  
)

export default component.exports